import type { Rooms } from "./data-types.ts";

export const rooms = {
  A001: [85, 156, 0],
  A002: [77, 160, 0],
  A004: [74, 149, 0],
  A211: [80, 143, 2],
  A212: [80, 113, 2],
  A213: [80, 137, 2],
  A214: [80, 130, 2],
  B100: [87, 114, 1],
  B101: [96, 125, 1],
  B102: [96, 112, 1],
  B103: [101, 120, 1],
  B104: [102, 118, 1],
  B105: [103, 120, 1],
  B106: [106, 118, 1],
  B107: [108, 125, 1],
  B108: [108, 112, 1],
  B109: [113, 120, 1],
  B110: [110, 118, 1],
  B111: [115, 120, 1],
  B112: [118, 118, 1],
  B113: [120, 125, 1],
  B114: [120, 112, 1],
  B115: [122, 118, 1],
  B116: [126, 120, 1],
  B200: [88, 113, 2],
  B201: [96, 125, 2],
  B202: [96, 112, 2],
  B203: [101, 120, 2],
  B205: [103, 120, 2],
  B206: [105, 117, 2],
  B208: [109, 114, 2],
  B209: [115, 120, 2],
  B212: [113, 117, 2],
  B213: [122, 125, 2],
  B214: [122, 114, 2],
  B215: [124, 120, 2],
  B216: [124, 117, 2],
  C200: [85, 120, 2],
  C202: [80, 120, 2],
  C203: [76, 87, 2],
  C204: [89, 88, 2],
  C205: [80, 113, 2],
  C206: [80, 113, 2],
  C207: [80, 113, 2],
  C208: [80, 113, 2],
  C209: [80, 113, 2],
  C210: [80, 113, 2],
  C211: [80, 113, 2],
  C212: [80, 113, 2],
  C213: [80, 113, 2],
  C214: [80, 113, 2],
  C215: [80, 113, 2],
  C216: [80, 113, 2],
  C217: [80, 113, 2],
  C218: [80, 113, 2],
  C219: [80, 113, 2],
  C220: [80, 113, 2],
  C221: [80, 113, 2],
  C222: [80, 113, 2],
  C223: [80, 113, 2],
  C224: [80, 113, 2],
  C225: [80, 113, 2],
  C226: [80, 113, 2],
  D100: [65, 113, 1],
  D101: [64, 125, 1],
  D102: [64, 111, 1],
  D103: [59, 121, 1],
  D104: [62, 116, 1],
  D105: [57, 121, 1],
  D106: [54, 116, 1],
  D107: [52, 126, 1],
  D108: [52, 111, 1],
  D109: [46, 121, 1],
  D110: [48, 113, 1],
  D111: [44, 121, 1],
  D112: [41, 116, 1],
  D113: [39, 126, 1],
  D114: [39, 111, 1],
  D115: [34, 121, 1],
  D116: [37, 116, 1],
  D200: [66, 118, 2],
  D201: [65, 125, 2],
  D202: [65, 112, 2],
  D203: [60, 120, 2],
  D204: [61, 117, 2],
  D205: [58, 120, 2],
  D206: [57, 117, 2],
  D207: [53, 125, 2],
  D208: [53, 112, 2],
  D209: [47, 120, 2],
  D210: [49, 117, 2],
  D211: [45, 120, 2],
  D212: [43, 117, 2],
  D213: [40, 125, 2],
  D214: [40, 112, 2],
  D215: [35, 120, 2],
  D216: [38, 117, 2],
  E100: [100, 102, 1],
  E101: [108, 79, 1],
  E102: [98, 76, 1],
  E103: [122, 73, 1],
  E200: [91, 88, 2],
  E201: [96, 80, 2],
  E202: [98, 74, 2],
  E203: [104, 77, 2],
  E204: [105, 74, 2],
  E205: [117, 77, 2],
  E206: [114, 74, 2],
  E207: [119, 77, 2],
  E209: [119, 77, 2],
  E210: [121, 74, 2],
  E212: [122, 73, 2],
  F100: [77, 12, 1],
  F101: [80, 75, 1],
  F102: [81, 12, 1],
  F103: [81, 54, 1],
  F104: [91, 12, 1],
  F105: [81, 23, 1],
  F106: [95, 12, 1],
  F108: [103, 12, 1],
  F110: [97, 20, 1],
  F112: [99, 32, 1],
  F114: [99, 41, 1],
  F116: [97, 49, 1],
  F118: [97, 54, 1],
  F200: [76, 12, 2],
  F201: [81, 60, 2],
  F202: [80, 12, 2],
  F203: [81, 54, 2],
  F204: [89, 12, 2],
  F206: [94, 12, 2],
  F208: [103, 12, 2],
  F209: [0, 0, 0],
  F210: [96, 18, 2],
  F211: [0, 0, 0],
  F212: [98, 33, 2],
  F216: [99, 44, 2],
  F218: [96, 56, 2],
  G101: [60, 77, 1],
  G102: [64, 74, 1],
  G104: [62, 73, 1],
  G105: [55, 77, 1],
  G106: [60, 73, 1],
  G107: [49, 77, 1],
  G108: [51, 73, 1],
  G110: [49, 73, 1],
  G112: [40, 73, 1],
  G113: [41, 77, 1],
  G114: [37, 73, 1],
  G201: [66, 84, 2],
  G202: [66, 72, 2],
  G204: [66, 66, 2],
  G205: [57, 81, 2],
  G206: [55, 72, 2],
  G207: [52, 79, 2],
  G209: [41, 77, 2],
  G210: [45, 71, 2],
  G211: [40, 81, 2],
  G212: [43, 71, 2],
  G213: [38, 81, 2],
  G214: [35, 73, 2],
  G215: [37, 77, 2],
  H100: [68, 12, 1],
  H102: [58, 8, 1],
  H103: [58, 19, 1],
  H104: [58, 6, 1],
  H106: [56, 12, 1],
  H107: [53, 15, 1],
  H108: [48, 12, 1],
  H109: [46, 20, 1],
  H110: [46, 6, 1],
  H111: [40, 15, 1],
  H112: [39, 12, 1],
  H113: [38, 15, 1],
  H115: [33, 20, 1],
  H116: [33, 6, 1],
  H117: [33, 15, 1],
  H118: [30, 12, 1],
  H200: [68, 13, 2],
  H202: [59, 8, 2],
  H203: [58, 20, 2],
  H204: [58, 6, 2],
  H205: [52, 15, 2],
  H206: [55, 11, 2],
  H207: [50, 15, 2],
  H208: [48, 11, 2],
  H209: [45, 20, 2],
  H210: [45, 6, 2],
  H211: [40, 15, 2],
  H212: [40, 11, 2],
  H213: [38, 15, 2],
  H214: [36, 11, 2],
  H215: [33, 20, 2],
  H216: [33, 6, 2],
  H217: [28, 15, 2],
  H218: [28, 11, 2],
} as const satisfies Rooms;
